const collaborationMap = {
  city: Drupal.t('City'),
  company: Drupal.t('Partner company'),
};

export default collaborationMap;
